module.exports = "/_next/static/images/equity_research_mobile-03e8970aff1d28c98e9aa042d2056519.jpg";